import React from 'react';

/**
 * The login screen's backdrop: a drafting-table surface for an industrial tool.
 *
 * Three layers, all deliberately near the threshold of visible — they should
 * register as texture, not as artwork, and none of them may compete with the
 * card. Everything is CSS and inline SVG; no illustration dependency.
 */
const LoginBackdrop: React.FC = () => (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        {/* 1. Graph-paper grid, 64px, fading out toward the edges so it never
               reaches the viewport boundary as a hard pattern. */}
        <div
            className="absolute inset-0 opacity-[0.55]"
            style={{
                backgroundImage:
                    'linear-gradient(to right, #E7EAF0 1px, transparent 1px), linear-gradient(to bottom, #E7EAF0 1px, transparent 1px)',
                backgroundSize: '64px 64px',
                maskImage: 'radial-gradient(ellipse 85% 70% at 50% 45%, #000 40%, transparent 100%)',
                WebkitMaskImage: 'radial-gradient(ellipse 85% 70% at 50% 45%, #000 40%, transparent 100%)',
            }}
        />

        {/* 2. Blueprint guide lines — two 30° diagonals, the angle the cubes are
               drawn on, so the decoration shares one geometry. */}
        <svg className="absolute inset-0 h-full w-full" preserveAspectRatio="none">
            <line x1="0" y1="82%" x2="100%" y2="24%" stroke="#D8DEE8" strokeWidth="1" strokeDasharray="7 9" />
            <line x1="0" y1="103%" x2="100%" y2="45%" stroke="#E2E7EF" strokeWidth="1" />
        </svg>

        {/* 3. Two isometric cubes, bottom-right, translucent. The only ornament,
               and the same solid the brand mark is built from. */}
        <svg
            className="absolute -bottom-6 right-[-2rem] h-[300px] w-[300px] opacity-[0.3] sm:right-2 lg:h-[340px] lg:w-[340px]"
            viewBox="0 0 220 220"
            fill="none"
        >
            <g stroke="#CFD7E3" strokeWidth="1" strokeLinejoin="round">
                <g>
                    <path d="M70 58L118 85L70 112L22 85L70 58Z" fill="#4C86D4" fillOpacity="0.045" />
                    <path d="M22 85L70 112V166L22 139V85Z" fill="#0F1317" fillOpacity="0.035" />
                    <path d="M118 85V139L70 166V112L118 85Z" fill="#0F1317" fillOpacity="0.055" />
                </g>
                <g opacity="0.7">
                    <path d="M150 96L186 117L150 138L114 117L150 96Z" fill="#4C86D4" fillOpacity="0.04" />
                    <path d="M114 117L150 138V180L114 159V117Z" fill="#0F1317" fillOpacity="0.03" />
                    <path d="M186 117V159L150 180V138L186 117Z" fill="#0F1317" fillOpacity="0.05" />
                </g>
            </g>
        </svg>
    </div>
);

export default LoginBackdrop;
